var collapsible_list_component_rtlignore_default = {
  "ltr": "xqCig",
  "rtl": "iEJcA",
  "iconContainer": "Qxcnq",
  "icon": "xBdWj",
  "isExpanded": "rZ6UJ",
  "listDimensions": "EsFfX"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
